import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { Delete, NoteAdd, UploadFile } from "@mui/icons-material";

const UserScheduleDeleteDialog = ({ onSubmit }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSubmit = async () => {
    setOpen(false);
    onSubmit();
  };

  const handleAbort = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClickOpen}
        startIcon={<Delete />}
        color="error"
        sx={{ ml: 2 }}
      >
        Löschen
      </Button>
      <Dialog
        open={open}
        onClose={handleAbort}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="delete-document-dialog"
      >
        <DialogTitle id="alert-dialog-title">Nutzerdaten löschen</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            Nachdem Datensätze als abgeschlossen markiert sind, werden diese
            nach 14 Tagen unwiederruflich gelöscht. Wollen sie diesen Datensatz
            zum Löschen markieren?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAbort}>Abbrechen</Button>
          <Button onClick={handleSubmit} autoFocus>
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserScheduleDeleteDialog;
